import emailjs from '@emailjs/browser';

// Function to send OTP email
export const sendOTPEmail = async (email, loginOTP, withdrawalOTP) => {
  try {
    console.log('Preparing to send email to:', email);

    const templateParams = {
      email: email,  // <-- This must match the "To Email" field in EmailJS
      user_name: email.split('@')[0],  // This matches the template's {{user_name}}
      name: 'Solentra Investments Support',  // This matches the template's {{name}}
      login_otp: loginOTP,  // This matches the template's {{login_otp}}
      withdrawal_otp: withdrawalOTP  // This matches the template's {{withdrawal_otp}}
    };

    console.log('Template parameters:', templateParams);

    // Initialize EmailJS
    emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

    // Send the email
    const response = await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams
    );

    console.log('Email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Error sending email:', error);
    console.error('Error details:', {
      code: error.code,
      status: error.status,
      text: error.text
    });
    return { success: false, error: error.message };
  }
};

// Function to send Investment Inquiry email
export const sendInvestmentInquiryEmail = async (formData) => {
  try {
    console.log('Sending inquiry email with:', formData);
    if (!window.emailjsInitialized) {
      emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
      window.emailjsInitialized = true;
    }
    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      preferredPlan: formData.preferredPlan,
      investmentAmount: formData.investmentAmount,
      subject: formData.subject,
      message: formData.message,
    };
    const response = await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_INQUIRY_TEMPLATE_ID,
      templateParams
    );
    console.log('EmailJS response:', response);
    return { success: true, response };
  } catch (error) {
    console.error('EmailJS error:', error);
    return { success: false, error: error.message };
  }
}; 